import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWrite3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="write-3, fountain-pen, vector, ink"><path d="M4 21.25H20" stroke="currentColor" strokeWidth="1.6"/><path d="M7.85714 21.25L4.75 13.25L12 3.25L19.25 13.25L16.1429 21.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="14" r="2" stroke="currentColor" strokeWidth="1.5"/><path d="M12 12V4.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWrite3;
